import React, { FC } from 'react';
import JourneySlideover from 'src/common/JourneySlideOver';
import classNames from 'classnames';

type Props = {
  open: boolean;
  onClose: () => unknown;
  utmParams?: string;
};

export const DashboardInsightsJourneysJourneyUtmDetailsSlideover: FC<Props> = ({ open, onClose, utmParams }) => {
  return (
    <JourneySlideover isBedrock open={open} panelClassName='w-[368px]' title='UTM details' onClose={onClose}>
      <div className='mt-2 flex flex-col w-full items-start gap-4'>
        {utmParams &&
          utmParams.split('&').map((param: string) => (
            <div key={param} className='flex flex-col'>
              {param.split('=').map((key: string, i: number) => (
                <div
                  key={i}
                  className={classNames('text-bedrock-black', {
                    'text-bedrock-p-strong': i === 0,
                    'text-bedrock-p': i !== 0,
                  })}
                >
                  {key}
                </div>
              ))}
            </div>
          ))}
      </div>
    </JourneySlideover>
  );
};
